import { createContext } from 'react';

import { Tkv2OrderContext as Tkv2OrderContextType } from './types.js';

export const Tkv2OrderContext = createContext<Tkv2OrderContextType | null>(null);
